import "core-js/modules/es.array.filter";
import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import InfoTooltip from '@comp/forms/InfoTooltip.vue';
import { statisticNumbersFormatter } from '@utils/format-number';
import Icon from '@comp/Icon.vue';
import LeaderBage from '!!url-loader?!@static/icons/leader-bage.svg';
import { ordinalSuffix } from '@utils/misc';
export default {
  name: 'UserAvatar',
  components: {
    InfoTooltip: InfoTooltip,
    Icon: Icon
  },
  filters: {
    statisticNumbersFormatter: statisticNumbersFormatter
  },
  props: {
    src: String,
    size: {
      type: [Number, String],
      default: 50
    },
    stats: Object,
    firstName: {
      type: String,
      default: null
    },
    lastName: {
      type: String,
      default: null
    },
    leaderBoardPosition: Number,
    hotBoardPosition: Number,
    positionGrayAfter: Number
  },
  data: function data() {
    return {
      LeaderBage: LeaderBage
    };
  },
  computed: {
    boardPositionBadge: function boardPositionBadge() {
      var pos = undefined;

      if (this.leaderBoardPosition && this.hotBoardPosition) {
        pos = this.leaderBoardPosition <= this.hotBoardPosition ? 'leaderBoard' : 'hotBoard';
      } else {
        pos = this.leaderBoardPosition ? 'leaderBoard' : this.hotBoardPosition ? 'hotBoard' : undefined;
      }

      if (!pos) return undefined;
      return pos === 'leaderBoard' ? {
        position: this.leaderBoardPosition,
        className: this.positionGrayAfter && this.leaderBoardPosition > this.positionGrayAfter ? 'position-bage-gray' : 'position-bage-green',
        title: "Currently ranked ".concat(ordinalSuffix(this.leaderBoardPosition), " on All-Time Leaderboard")
      } : {
        position: this.hotBoardPosition,
        className: this.positionGrayAfter && this.hotBoardPosition > this.positionGrayAfter ? 'position-bage-gray' : 'position-bage-orange',
        title: "Currently ranked ".concat(ordinalSuffix(this.hotBoardPosition), " on Hot Board")
      };
    },
    photoPlaceholder: function photoPlaceholder() {
      return ((this.firstName || '').substr(0, 1) + (this.lastName || '').substr(0, 1)).toUpperCase();
    },
    totalPicks: function totalPicks() {
      if (!this.stats) return 0;
      return this.stats.winnings + this.stats.loses + this.stats.push;
    },
    winningsPercentage: function winningsPercentage() {
      if (this.stats && this.stats.proc) {
        return this.stats.proc;
      } else {
        var totalWinLose = this.stats.winnings + this.stats.loses;
        return totalWinLose > 0 ? 100 * this.stats.winnings / totalWinLose : 0;
      }
    },
    options: function options() {
      if (!this.stats) {
        return {
          winnings: 0,
          loses: 0,
          push: 0
        };
      }

      if (this.totalPicks === 0) {
        return {
          winnings: 0,
          loses: 0,
          push: 1
        };
      }

      return {
        winnings: this.stats.winnings / this.totalPicks,
        loses: this.stats.loses / this.totalPicks,
        push: this.stats.push / this.totalPicks
      };
    },
    circelConfig: function circelConfig() {
      var r = 48;
      var c = Math.PI * (r * 2);
      var placeholderK = 0.15;
      var gapK = 0.01;
      var gapsCount = Math.max([this.options.winnings, this.options.loses, this.options.push].filter(function (x) {
        return x > 0;
      }).length - 1, 0);
      var winningsK = this.options.winnings - this.options.winnings * placeholderK - gapsCount * this.options.winnings * gapK;
      var losesK = this.options.loses - this.options.loses * placeholderK - gapsCount * this.options.loses * gapK;
      var pushK = this.options.push - this.options.push * placeholderK - gapsCount * this.options.push * gapK;
      var placeholderRotate = 90 - 360 * placeholderK / 2;
      var winnings = {
        rotate: placeholderRotate + 360 * placeholderK,
        dashoffset: c * (1 - winningsK)
      };
      var loses = {
        rotate: winnings.rotate + 360 * winningsK + (this.options.winnings > 0 && gapsCount-- > 0 ? 360 * gapK : 0),
        dashoffset: c * (1 - losesK)
      };
      var push = {
        rotate: loses.rotate + 360 * losesK + ((this.options.winnings > 0 || this.options.loses > 0) && gapsCount-- > 0 ? 360 * gapK : 0),
        dashoffset: c * (1 - pushK)
      };
      return {
        r: r,
        c: c,
        winnings: winnings,
        loses: loses,
        push: push
      };
    }
  }
};